import { InspectionStatuses } from './../models/Inspection';
import { FormControl, ValidationErrors } from "@angular/forms";

export function legacyFacilityValidator(control: FormControl): ValidationErrors {
	return control.value && !(control.value.isLegacyData && control.value.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED)
	  ? null
	  : { legacy: true };
  }
  
  export function legacyFacilityValidationMessage(err, field) {
	return `The selected facility data needs to be edited`;
  }